module.exports = __webpack_public_path__ + "img/Locacion.b5644273.svg";